import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AddVehicleRes;
export const AddVehicleTodo = createAsyncThunk('AddVehicle', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Post",
            url: process.env.REACT_APP_API_URL + 'vehicle_master',
            data: data ,
            headers: { "Content-Type": "multipart/form-data" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AddVehicleRes = res.data
        
    } catch (error) {
        return AddVehicleRes = error.response.data
    }
})
